import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
// import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 15000
})

// request
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = 'Bearer ' + store.getters.token
  }
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

// response
service.interceptors.response.use(
  response => {
    return response.data
  },
  async error => {
    // console.log('err response' + JSON.stringify(error.response))// for debug
    let errorMessage = ''
    if (error.response) {
      let responseData = {}
      if (error.request.responseType === 'blob') {
        responseData = JSON.parse(await error.response.data.text())
      } else {
        responseData = error.response.data
      }
      if (error.response.status === 422) {
        errorMessage = `${Object.keys(responseData).map(err => responseData[err].length > 0 ? responseData[err][0] : responseData[err])}`
      } else if (error.response.status === 403) {
        // console.log(error.response)
        errorMessage = responseData.message
      } else {
        // console.log(error.response)
        errorMessage = responseData.message ?
        Array.isArray(responseData.message) && responseData.message[0] ?
          responseData.message[0].messages && responseData.message[0].messages.length > 0 ?
            responseData.message[0].messages[0] ?
              responseData.message[0].messages[0].message
              :
              responseData.message[0].messages
            :
            responseData.message[0]
          :
          responseData.message
        :
        responseData.error
      }
    } else {
      errorMessage = error.message === 'Network Error' ? 'Network Error. Please check your internet connection.' : error.message
    }
    Message({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js